import { TAU } from "../math.ts";

interface Particle {
  x: number;
  y: number;
  vx: number;
  vy: number;
  life: number;
  maxLife: number;
  r: number;
  color: string;
}

interface FloatText {
  x: number;
  y: number;
  vy: number;
  life: number;
  maxLife: number;
  text: string;
  color: string;
  size: number;
}

export class Particles {
  private particles: Particle[] = [];
  private texts: FloatText[] = [];

  burst(x: number, y: number, color: string, count = 8, speed = 120) {
    for (let i = 0; i < count; i++) {
      const a = Math.random() * TAU;
      const s = speed * (0.4 + Math.random() * 0.6);
      this.particles.push({
        x,
        y,
        vx: Math.cos(a) * s,
        vy: Math.sin(a) * s,
        life: 0,
        maxLife: 0.4 + Math.random() * 0.4,
        r: 2 + Math.random() * 4,
        color,
      });
    }
  }

  ring(x: number, y: number, color: string, count = 20, speed = 220) {
    for (let i = 0; i < count; i++) {
      const a = (i / count) * TAU;
      this.particles.push({
        x,
        y,
        vx: Math.cos(a) * speed,
        vy: Math.sin(a) * speed,
        life: 0,
        maxLife: 0.6,
        r: 3 + Math.random() * 3,
        color,
      });
    }
  }

  float(x: number, y: number, text: string, color = "#fff", size = 20) {
    this.texts.push({ x, y, vy: -60, life: 0, maxLife: 1, text, color, size });
  }

  update(dt: number) {
    for (let i = this.particles.length - 1; i >= 0; i--) {
      const p = this.particles[i];
      p.life += dt;
      if (p.life >= p.maxLife) {
        this.particles.splice(i, 1);
        continue;
      }
      p.x += p.vx * dt;
      p.y += p.vy * dt;
      p.vx *= 1 - 3 * dt;
      p.vy *= 1 - 3 * dt;
    }
    for (let i = this.texts.length - 1; i >= 0; i--) {
      const tx = this.texts[i];
      tx.life += dt;
      if (tx.life >= tx.maxLife) {
        this.texts.splice(i, 1);
        continue;
      }
      tx.y += tx.vy * dt;
      tx.vy *= 1 - 1.5 * dt;
    }
  }

  /** Draw in WORLD space (call inside the camera transform). */
  draw(ctx: CanvasRenderingContext2D) {
    for (const p of this.particles) {
      const a = 1 - p.life / p.maxLife;
      ctx.globalAlpha = a;
      ctx.fillStyle = p.color;
      ctx.beginPath();
      ctx.arc(p.x, p.y, p.r * a, 0, TAU);
      ctx.fill();
    }
    ctx.globalAlpha = 1;

    for (const tx of this.texts) {
      const a = 1 - tx.life / tx.maxLife;
      ctx.globalAlpha = a;
      ctx.fillStyle = tx.color;
      ctx.font = `900 ${tx.size}px system-ui, sans-serif`;
      ctx.textAlign = "center";
      ctx.lineWidth = 4;
      ctx.strokeStyle = "rgba(0,0,0,0.4)";
      ctx.strokeText(tx.text, tx.x, tx.y);
      ctx.fillText(tx.text, tx.x, tx.y);
    }
    ctx.globalAlpha = 1;
    ctx.textAlign = "left";
  }
}
